import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768;

/**
 * Returns true when the viewport width is below the mobile breakpoint (768px).
 * Updates reactively on window resize.
 */
export const useIsMobile = (breakpoint: number = MOBILE_BREAKPOINT): boolean => {
    const [isMobile, setIsMobile] = useState<boolean>(
        () => window.innerWidth < breakpoint
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
};
